module.exports = __webpack_public_path__ + "pc/img/pc_logo_wh.20806d3d.svg";